export default "__VITE_PUBLIC_ASSET__9acbe754__"